"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemTypeMeta = exports.getItemTypeMeta = void 0;
const enums_1 = require("../core/enums");
const Record_1 = require("../utils/Record");
function getItemTypeMeta(type, defaultValue = enums_1.ItemType.None) {
    const typeEnum = typeof type === "number" ? type : enums_1.ItemType[type];
    return (0, Record_1.getValueOrDefault)(exports.ItemTypeMeta, typeEnum, exports.ItemTypeMeta[defaultValue]);
}
exports.getItemTypeMeta = getItemTypeMeta;
exports.ItemTypeMeta = {
    [enums_1.ItemType.None]: mkMeta("None", { skip: true }),
    [enums_1.ItemType.Consumable]: mkMeta("Consumable", { consumable: true }),
    [enums_1.ItemType.Ring]: mkMeta("Ring", {}),
    [enums_1.ItemType.Necklace]: mkMeta("Necklace", {}),
    [enums_1.ItemType.Armor]: mkMeta("Armor", {}),
    [enums_1.ItemType.OneHandedWeapon]: mkMeta("OneHandedWeapon", { abbreviation: "1H Weapon" }),
    [enums_1.ItemType.TwoHandedWeapon]: mkMeta("TwoHandedWeapon", { abbreviation: "2H Weapon" }),
    [enums_1.ItemType.Shield]: mkMeta("Shield", {}),
    [enums_1.ItemType.OffHandItem]: mkMeta("OffHandItem", { label: "Offhand Weapon", abbreviation: "Offhand" }),
    [enums_1.ItemType.CharacterSkin]: mkMeta("CharacterSkin", { label: "Skin", abbreviation: "Skin" }),
    [enums_1.ItemType.Helmet]: mkMeta("Helmet", { label: "Helmet", abbreviation: "Helmet" }),
    [enums_1.ItemType.Hat]: mkMeta("Hat", { label: "Hat", abbreviation: "Hat" }),
    [enums_1.ItemType.Charm]: mkMeta("Charm", { label: "Charm", abbreviation: "Charm" })
};
function mkMeta(key, extra = {}) {
    const display = key.replace(/([A-Z])/g, " $1").slice(1);
    return {
        key,
        type: enums_1.ItemType[key],
        label: display,
        abbreviation: display,
        skip: false,
        consumable: false,
        ...extra,
    };
}
